import { useEffect } from 'react';

import type { UseAddEditBrandEffectsProps } from '@app/pages/Warehouses/Brands/components/AddEditBrand/types';

export const useAddEditBrandEffects = ({
  initForm,
  skipForm,
}: UseAddEditBrandEffectsProps) => {
  useEffect(() => {
    initForm();

    return skipForm;
  }, [initForm, skipForm]);
};
